export const MAX_LETTER_COUNT = 300;

export enum FieldsNames {
  FeedbackText = 'inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest.feedbackText',
  OtherFeedbackText = 'inspiredGlobalStudyPlatformApiModelsParentHelperAnswerFeedbackRequest.otherFeedbackText',
}
